import React from 'react';
import { Wallet, ArrowDownLeft, Clock, CheckCircle2, Download, Filter } from 'lucide-react';
const history = [{
  id: 'PO-9901',
  date: 'Oct 14, 2023',
  amount: 4200,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9900',
  date: 'Oct 01, 2023',
  amount: 3150,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9899',
  date: 'Sep 15, 2023',
  amount: 2800,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}];
export function Payouts() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-3094">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-3095">
        <div data-id="element-3096">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-3097">Partner Payouts</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-3098">
            Withdraw your earnings and manage settlement frequency.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-3099">
          <ArrowDownLeft size={18} data-id="element-3100" />
          Request Instant Payout
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3101">
        <div className="bg-slate-900 p-6 rounded-lg text-white" data-id="element-3102">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-3103">
            Available for Withdrawal
          </p>
          <h3 className="text-3xl font-bold" data-id="element-3104">$12,450.00</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-indigo-400" data-id="element-3105">
            <Clock size={14} data-id="element-3106" />
            <span data-id="element-3107">Next auto-payout in 3 days</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-3108">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-3109">
            Total Withdrawn (YTD)
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-3110">$84,200.00</h3>
          <p className="mt-4 text-xs font-bold text-emerald-600 flex items-center gap-1" data-id="element-3111">
            <CheckCircle2 size={14} data-id="element-3112" /> 12 Successful Payouts
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-3113">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-3114">
            Pending Clearance
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-3115">$5,120.00</h3>
          <div className="mt-4 w-full bg-gray-100 h-1.5 rounded-full overflow-hidden" data-id="element-3116">
            <div className="h-full bg-indigo-600 w-2/3" data-id="element-3117"></div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3118">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between bg-gray-50/50" data-id="element-3119">
          <h3 className="font-bold text-slate-900" data-id="element-3120">Payout History</h3>
          <div className="flex gap-2" data-id="element-3121">
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-3122">
              <Filter size={18} data-id="element-3123" />
            </button>
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-3124">
              <Download size={18} data-id="element-3125" />
            </button>
          </div>
        </div>
        <table className="w-full text-left border-collapse" data-id="element-3126">
          <thead data-id="element-3127">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100" data-id="element-3128">
              <th className="px-6 py-4" data-id="element-3129">Payout ID</th>
              <th className="px-6 py-4" data-id="element-3130">Date</th>
              <th className="px-6 py-4" data-id="element-3131">Amount</th>
              <th className="px-6 py-4" data-id="element-3132">Method</th>
              <th className="px-6 py-4" data-id="element-3133">Status</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-3134">
            {history.map(h => <tr key={h.id} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0" data-id="element-3135">
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-3136">{h.id}</td>
                <td className="px-6 py-4 text-gray-500" data-id="element-3137">{h.date}</td>
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-3138">
                  ${h.amount.toLocaleString()}.00
                </td>
                <td className="px-6 py-4 text-gray-500 font-medium" data-id="element-3139">
                  {h.method}
                </td>
                <td className="px-6 py-4" data-id="element-3140">
                  <span className="px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-50 text-emerald-600" data-id="element-3141">
                    {h.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}